module.exports = '4.8.1';



// WEBPACK FOOTER //
// ./src/version.js